<template>
<div class="chapter">
<div class="inner_page">
<section aria-labelledby="headertoc01" class="chapter" epub:type="toc" id="toc" role="doc-toc">
<header id="headertoc01">
<h1 class="ctfm"><span aria-label="v" class="page" epub:type="pagebreak" id="pv" role="doc-pagebreak"></span>Contents</h1>
</header>
<p class="tocfmf" style="font-style: normal;"><a class="xref" href="#/chibartram0006#pref">Preface</a></p>
<p class="tocfm" style="font-style: normal;"><a class="xref" href="#/chibartram0007#intro">Introduction</a></p>
<p class="toc"><a class="xref" href="#/chibartram0008#ch01"><span class="sm">CHAPTER</span> <span class="sm">1.</span>  Stacked Decks</a></p>
<p class="toc"><a class="xref" href="#/chibartram0009#ch02"><span class="sm">CHAPTER</span> <span class="sm">2.</span>  Building Inspections</a></p>
<p class="toc"><a class="xref" href="#/chibartram0010#ch03"><span class="sm">CHAPTER</span> <span class="sm">3.</span>  Rentals and Relative Assessments</a></p>
<p class="toc"><a class="xref" href="#/chibartram0011#ch04"><span class="sm">CHAPTER</span> <span class="sm">4.</span>  Helping Out Homeowners: Changing Faces and Stubborn Realities</a></p>
<p class="toc"><a class="xref" href="#/chibartram0012#ch05"><span class="sm">CHAPTER</span> <span class="sm">5.</span>  Justice Blockers</a></p>
<p class="toc"><a class="xref" href="#/chibartram0013#conc"><span class="sm">CONCLUSION.</span>  Reshuffling the Deck</a></p>
<p class="tocbmf" style="font-style: normal;"><a class="xref" href="#/chibartram0014#acknow">Acknowledgments</a></p>
<p class="tocbm" style="font-style: normal;"><a class="xref" href="#/chibartram0015#appa"><span class="sm">APPENDIX</span> <span class="sm">A.</span>  Methodology</a></p>
<p class="tocbm" style="font-style: normal;"><a class="xref" href="#/chibartram0016#appb"><span class="sm">APPENDIX</span> <span class="sm">B.</span>  Building Violation Counts</a></p>
<p class="tocbm" style="font-style: normal;"><a class="xref" href="#/chibartram0017#appc"><span class="sm">APPENDIX</span> <span class="sm">C.</span>  Map of Strategic Task Force Inspections</a></p>
<p class="tocbm" style="font-style: normal;"><a class="xref" href="#/chibartram0018#notes">Notes</a></p>
<p class="tocbm" style="font-style: normal;"><a class="xref" href="#/chibartram0019#refs">References</a></p>
<p class="tocbm" style="font-style: normal;"><a class="xref" href="#/chibartram0020#index">Index</a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-bartram-0005.vue?d3622ab2